import React from 'react';
import { FaUsers, FaHome, FaCity, FaClipboardList, FaNewspaper, FaCommentDots, FaUserSecret, FaClone, FaRegEdit, FaFilm, FaFileAlt, FaTools } from 'react-icons/fa';
import { ImFilm } from "react-icons/im";
import { SidebarOption } from './CommonConsts';
export const searchAll = 9999;
const allObject = { key: searchAll, value: '全て' };
const unspecifiedObject = { key: searchAll, value: '指定なし' };
export var AdminSidebarStatusEnum;
(function (AdminSidebarStatusEnum) {
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Home"] = 1] = "Home";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["User"] = 2] = "User";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Company"] = 3] = "Company";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["UserConfirmDocument"] = 4] = "UserConfirmDocument";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["JobInfoParent"] = 5] = "JobInfoParent";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["JobInfo"] = 6] = "JobInfo";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["JobinfoApplication"] = 7] = "JobinfoApplication";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["RecruitmentParent"] = 8] = "RecruitmentParent";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Recruitment"] = 9] = "Recruitment";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["RecruitmentApplication"] = 10] = "RecruitmentApplication";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["VideoParent"] = 11] = "VideoParent";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Video"] = 12] = "Video";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["VideoSample"] = 13] = "VideoSample";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Training"] = 14] = "Training";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Exam"] = 15] = "Exam";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Admin"] = 16] = "Admin";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Notification"] = 17] = "Notification";
    AdminSidebarStatusEnum[AdminSidebarStatusEnum["Setting"] = 18] = "Setting";
})(AdminSidebarStatusEnum || (AdminSidebarStatusEnum = {}));
export const SidebarInfo = [
    {
        key: AdminSidebarStatusEnum.Home,
        title: 'ホーム',
        href: '/admin/home',
        svg: React.createElement(FaHome, null),
    },
    {
        key: AdminSidebarStatusEnum.User,
        title: '職人一覧',
        href: '/admin/user_list',
        svg: React.createElement(FaUsers, null),
    },
    {
        key: AdminSidebarStatusEnum.Company,
        title: '事業者一覧',
        href: '/admin/company_list',
        svg: React.createElement(FaCity, null),
    },
    {
        key: AdminSidebarStatusEnum.UserConfirmDocument,
        title: '本人確認書類管理',
        href: '/admin/document_list',
        svg: React.createElement(FaFileAlt, null),
    },
    {
        key: AdminSidebarStatusEnum.JobInfoParent,
        title: '仕事管理',
        option: SidebarOption.Accordion,
        svg: React.createElement(FaClipboardList, null),
        children_array: [
            {
                key: AdminSidebarStatusEnum.JobInfo,
                title: '仕事情報一覧',
                href: '/admin/jobinfo_list',
                svg: React.createElement(FaClipboardList, null),
            },
            {
                key: AdminSidebarStatusEnum.JobinfoApplication,
                title: '仕事応募一覧',
                href: '/admin/jobinfo/application_list',
                svg: React.createElement(FaCommentDots, null),
            },
        ],
    },
    {
        key: AdminSidebarStatusEnum.RecruitmentParent,
        title: '求人管理',
        option: SidebarOption.Accordion,
        svg: React.createElement(FaNewspaper, null),
        children_array: [
            {
                key: AdminSidebarStatusEnum.Recruitment,
                title: '求人情報一覧',
                href: '/admin/recruitment_list',
                svg: React.createElement(FaNewspaper, null),
            },
            {
                key: AdminSidebarStatusEnum.RecruitmentApplication,
                title: '求人応募一覧',
                href: '/admin/recruitment/application_list',
                svg: React.createElement(FaCommentDots, null),
            },
        ],
    },
    {
        key: AdminSidebarStatusEnum.VideoParent,
        title: '現場の極意管理',
        option: SidebarOption.Accordion,
        svg: React.createElement(FaFilm, null),
        children_array: [
            {
                key: AdminSidebarStatusEnum.Video,
                title: '現場の極意一覧',
                href: '/admin/videoPack_list',
                svg: React.createElement(FaFilm, null),
            },
            {
                key: AdminSidebarStatusEnum.VideoSample,
                title: '現場の極意サンプル',
                href: '/admin/videoSample_list',
                svg: React.createElement(ImFilm, null),
            },
        ],
    },
    {
        key: AdminSidebarStatusEnum.Exam,
        title: '認定試験一覧',
        href: '/admin/exam_list',
        svg: React.createElement(FaRegEdit, null),
    },
    {
        key: AdminSidebarStatusEnum.Admin,
        title: '管理者一覧',
        href: '/admin/admin_list',
        svg: React.createElement(FaUserSecret, null),
    },
    {
        key: AdminSidebarStatusEnum.Notification,
        title: 'お知らせ一覧',
        href: '/admin/notification_list',
        svg: React.createElement(FaClone, null),
    },
    {
        key: AdminSidebarStatusEnum.Setting,
        title: 'システム設定',
        href: '/admin/setting_edit',
        svg: React.createElement(FaTools, null),
    },
];
export var CrudStatusEnum;
(function (CrudStatusEnum) {
    CrudStatusEnum[CrudStatusEnum["RegisterForm"] = 1] = "RegisterForm";
    CrudStatusEnum[CrudStatusEnum["RegisterConfirm"] = 2] = "RegisterConfirm";
    CrudStatusEnum[CrudStatusEnum["RegisterComplete"] = 3] = "RegisterComplete";
    CrudStatusEnum[CrudStatusEnum["DeleteConfirm"] = 4] = "DeleteConfirm";
})(CrudStatusEnum || (CrudStatusEnum = {}));
export const CrudStatusList = [
    { key: CrudStatusEnum.RegisterForm, value: "入力" },
    { key: CrudStatusEnum.RegisterConfirm, value: "確認" },
    { key: CrudStatusEnum.RegisterComplete, value: "完了" },
    { key: CrudStatusEnum.DeleteConfirm, value: "削除確認" }
];
export const ConfirmMessage = '以下の内容で登録してもよろしいでしょうか';
export const CompleteMessage = '登録が完了しました';
const yearmake = () => {
    let yearArray = [];
    for (let year = 1900; year <= 2021; year++) {
        yearArray = [...yearArray, { key: year, value: year }];
    }
    return yearArray;
};
export const yearList = yearmake();
const monthmake = () => {
    let monthArray = [];
    for (let month = 1; month <= 12; month++) {
        monthArray = [...monthArray, { key: month, value: month }];
    }
    return monthArray;
};
export const monthList = monthmake();
const hoursmake = () => {
    let hoursArray = [{ key: searchAll, value: "" }];
    for (let hours = 0; hours <= 23; hours++) {
        hoursArray = [...hoursArray, { key: hours, value: hours + "時" }];
    }
    return hoursArray;
};
export const hoursList = hoursmake();
export const daymake = (year, month) => {
    let lastDay = 31;
    let dayArray = [];
    switch (month) {
        case 4:
        case 6:
        case 9:
        case 11:
            lastDay = 30;
            break;
        case 2:
            if (year) {
                if (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
                    lastDay = 29;
                }
                else {
                    lastDay = 28;
                }
            }
            break;
        default:
            lastDay = 31;
            break;
    }
    for (let day = 1; day <= lastDay; day++) {
        dayArray = [...dayArray, { key: day, value: day }];
    }
    return dayArray;
};
export const statusChangeMessage = 'ステータスを変更しました';
export const approvalCompleteMessage = '承認されました';
export const rejectCompleteMessage = '却下されました';
export const DeleteComplete = 'delete_complete';
export const ErrorMessage = 'エラーが発生しました';
export const ValidationErrMessage = '入力値に誤りがあります';
export const AdminIsNotProtect = 0;
export const AdminIsProtect = 1;
export const tbodyOptionOmit = 'tbodyOptionOmit';
export const tbodyOptionNumberFormat = 'tbodyOptionNumberFormat';
export const tbodyYMDFormat = 'tbodyYMDFormat';
export const IllegalValue = 'IllegalValue';
export const IllegalValueMessage = '不正な遷移です';
export const CompanyPassReminder = 'CompanyPassReminder';
var RecruitmentConditionEnum;
(function (RecruitmentConditionEnum) {
    RecruitmentConditionEnum[RecruitmentConditionEnum["S"] = 1] = "S";
    RecruitmentConditionEnum[RecruitmentConditionEnum["A"] = 2] = "A";
    RecruitmentConditionEnum[RecruitmentConditionEnum["B"] = 3] = "B";
    RecruitmentConditionEnum[RecruitmentConditionEnum["C"] = 4] = "C";
})(RecruitmentConditionEnum || (RecruitmentConditionEnum = {}));
export const RecruitmentConditions = [
    { key: RecruitmentConditionEnum.S, value: 'S' },
    { key: RecruitmentConditionEnum.A, value: 'A' },
    { key: RecruitmentConditionEnum.B, value: 'B' },
    { key: RecruitmentConditionEnum.C, value: 'C' },
];
export var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus[ApplicationStatus["application"] = 0] = "application";
    ApplicationStatus[ApplicationStatus["examination"] = 1] = "examination";
    ApplicationStatus[ApplicationStatus["reject"] = 2] = "reject";
    ApplicationStatus[ApplicationStatus["contract"] = 3] = "contract";
    // notCompatible = 1,
    // responseCompleted = 2,
    // interview = 3,
    // notAdopted = 5,
    // decline = 6,
    // outObTouch = 99,
})(ApplicationStatus || (ApplicationStatus = {}));
export const ApplicationStatusList = [
    { key: ApplicationStatus.application, value: '受付' },
    { key: ApplicationStatus.examination, value: '検討中' },
    { key: ApplicationStatus.reject, value: '見送り' },
    { key: ApplicationStatus.contract, value: '採用' },
    // { key: ApplicationStatus.notAdopted, value: '不採用' },
    // { key: ApplicationStatus.decline, value: '辞退' },
    // { key: ApplicationStatus.outObTouch, value: '音信不通' },
];
export const SearchApplicationStatusList = [allObject, ...ApplicationStatusList];
// export const SearchCompanyApplicationStatusList = SearchApplicationStatusList.filter(
//     (element) => element.key !== ApplicationStatus.notCompatible
// );
//管理者画面、仕事・求人一覧の本人確認書類ステータス
export var ConfirmDocumentStatus;
(function (ConfirmDocumentStatus) {
    ConfirmDocumentStatus[ConfirmDocumentStatus["confirm_none"] = 0] = "confirm_none";
    ConfirmDocumentStatus[ConfirmDocumentStatus["confirm_ok"] = 1] = "confirm_ok";
})(ConfirmDocumentStatus || (ConfirmDocumentStatus = {}));
export const ConfirmDocumentStatusList = [
    { key: ConfirmDocumentStatus.confirm_none, value: '未登録' },
    { key: ConfirmDocumentStatus.confirm_ok, value: '登録済' },
];
export const ConfirmDocumentStatusSearch = [allObject, ...ConfirmDocumentStatusList];
//管理者画面、会員タイプ
export var CompanyIsSubscriptionUserStatus;
(function (CompanyIsSubscriptionUserStatus) {
    CompanyIsSubscriptionUserStatus[CompanyIsSubscriptionUserStatus["company_is_subscription_user_invalid"] = 0] = "company_is_subscription_user_invalid";
    CompanyIsSubscriptionUserStatus[CompanyIsSubscriptionUserStatus["company_is_subscription_user_valid"] = 1] = "company_is_subscription_user_valid";
})(CompanyIsSubscriptionUserStatus || (CompanyIsSubscriptionUserStatus = {}));
export const CompanyIsSubscriptionUserStatusList = [
    { key: CompanyIsSubscriptionUserStatus.company_is_subscription_user_invalid, value: '無料会員' },
    { key: CompanyIsSubscriptionUserStatus.company_is_subscription_user_valid, value: '有料会員' },
];
export const CompanyIsSubscriptionUserStatusSearch = [allObject, ...CompanyIsSubscriptionUserStatusList];
export var UserAttribute;
(function (UserAttribute) {
    UserAttribute[UserAttribute["Individual"] = 0] = "Individual";
    UserAttribute[UserAttribute["Corporation"] = 1] = "Corporation";
})(UserAttribute || (UserAttribute = {}));
export const UserAttributeList = [
    { key: UserAttribute.Corporation, value: "法人" },
    { key: UserAttribute.Individual, value: "個人" },
];
export const UserAttributeSearch = [allObject, ...UserAttributeList];
export var UserRank;
(function (UserRank) {
    UserRank[UserRank["S"] = 1] = "S";
    UserRank[UserRank["A"] = 2] = "A";
    UserRank[UserRank["B"] = 3] = "B";
    UserRank[UserRank["C"] = 4] = "C";
})(UserRank || (UserRank = {}));
export const UserRankList = [
    { key: UserRank.S, value: "S" },
    { key: UserRank.A, value: "A" },
    { key: UserRank.B, value: "B" },
    { key: UserRank.C, value: "C" }
];
export const UserRankSearch = [allObject, ...UserRankList];
export var ExamQuestionModalType;
(function (ExamQuestionModalType) {
    ExamQuestionModalType[ExamQuestionModalType["None"] = 0] = "None";
    ExamQuestionModalType[ExamQuestionModalType["Detail"] = 1] = "Detail";
    ExamQuestionModalType[ExamQuestionModalType["New"] = 2] = "New";
    ExamQuestionModalType[ExamQuestionModalType["Edit"] = 3] = "Edit";
})(ExamQuestionModalType || (ExamQuestionModalType = {}));
export var TestChoicesType;
(function (TestChoicesType) {
    TestChoicesType[TestChoicesType["choice1"] = 1] = "choice1";
    TestChoicesType[TestChoicesType["choice2"] = 2] = "choice2";
    TestChoicesType[TestChoicesType["choice3"] = 3] = "choice3";
    TestChoicesType[TestChoicesType["choice4"] = 4] = "choice4";
})(TestChoicesType || (TestChoicesType = {}));
export const TestChoicesList = [
    { key: TestChoicesType.choice1, value: "選択肢1" },
    { key: TestChoicesType.choice2, value: "選択肢2" },
    { key: TestChoicesType.choice3, value: "選択肢3" },
    { key: TestChoicesType.choice4, value: "選択肢4" },
];
export const SiteTitle = "現場のヒーロー";
export var UserIndustry;
(function (UserIndustry) {
    UserIndustry[UserIndustry["plumber"] = 1] = "plumber";
    UserIndustry[UserIndustry["construction"] = 2] = "construction";
    UserIndustry[UserIndustry["others"] = 9999] = "others";
})(UserIndustry || (UserIndustry = {}));
export const UserIndustryList = [
    { key: UserIndustry.plumber, value: "配管工" },
    { key: UserIndustry.construction, value: "建築業" },
    { key: UserIndustry.others, value: "その他" },
];
export var RecruitmentEmployType;
(function (RecruitmentEmployType) {
    // None = 0,
    RecruitmentEmployType[RecruitmentEmployType["FullTimeWorker"] = 1] = "FullTimeWorker";
    RecruitmentEmployType[RecruitmentEmployType["ContractTimeWorker"] = 2] = "ContractTimeWorker";
    RecruitmentEmployType[RecruitmentEmployType["SubContractWorker"] = 3] = "SubContractWorker";
})(RecruitmentEmployType || (RecruitmentEmployType = {}));
export const RecruitmentEmploymentTypeList = [
    // { key: RecruitmentEmployType.None, value: '指定なし' },
    { key: RecruitmentEmployType.FullTimeWorker, value: '正社員' },
    { key: RecruitmentEmployType.ContractTimeWorker, value: '契約社員' },
    { key: RecruitmentEmployType.SubContractWorker, value: '業務委託' },
];
export const getRecruitmentEmploymentName = (value) => {
    const found = RecruitmentEmploymentTypeList.find((element) => element.key === value);
    if (found) {
        return found.value;
    }
    return '';
};
// export const FRecruitmentEmploymentType = RecruitmentEmploymentTypeList.filter(
//     (element) => element.key !== RecruitmentEmployType.None
// );
export const searchRecruitmentEmploymentType = [allObject, ...RecruitmentEmploymentTypeList];
export var CompanyAttribute;
(function (CompanyAttribute) {
    CompanyAttribute[CompanyAttribute["Corporation"] = 1] = "Corporation";
    CompanyAttribute[CompanyAttribute["Individual"] = 2] = "Individual";
})(CompanyAttribute || (CompanyAttribute = {}));
export const CompanyAttributeList = [
    { key: CompanyAttribute.Corporation, value: "法人" },
    { key: CompanyAttribute.Individual, value: "個人" },
];
export var moveType;
(function (moveType) {
    moveType[moveType["Edit"] = 0] = "Edit";
    moveType[moveType["List"] = 1] = "List";
})(moveType || (moveType = {}));
//１ページあたりの表示数
export const rowCount = 10;
export var inputType;
(function (inputType) {
    inputType["TEXT"] = "text";
    inputType["NUMBER"] = "number";
    inputType["PASSWORD"] = "password";
})(inputType || (inputType = {}));
// メッセージ更新間隔(秒数)
export const MESSAGE_UPDATE_INTERVAL = 30;
//ユーザーのスキル
export var UserSkill;
(function (UserSkill) {
    UserSkill[UserSkill["SkillA"] = 0] = "SkillA";
    UserSkill[UserSkill["SkillB"] = 1] = "SkillB";
    UserSkill[UserSkill["SkillC"] = 2] = "SkillC";
    UserSkill[UserSkill["SkillD"] = 3] = "SkillD";
    UserSkill[UserSkill["SkillE"] = 4] = "SkillE";
})(UserSkill || (UserSkill = {}));
export const UserSkillList = [
    { key: UserSkill.SkillA, value: "スキルA" },
    { key: UserSkill.SkillB, value: "スキルB" },
    { key: UserSkill.SkillC, value: "スキルC" },
    { key: UserSkill.SkillD, value: "スキルD" },
    { key: UserSkill.SkillE, value: "スキルE" }
];
//詳細のoptionType
export var detailOptionTypeEnum;
(function (detailOptionTypeEnum) {
    detailOptionTypeEnum[detailOptionTypeEnum["img_array"] = 1] = "img_array";
    detailOptionTypeEnum[detailOptionTypeEnum["img"] = 2] = "img";
    detailOptionTypeEnum[detailOptionTypeEnum["download"] = 3] = "download";
})(detailOptionTypeEnum || (detailOptionTypeEnum = {}));
//仕事情報の宿泊施設のenum
export var JobinfoHotelEnum;
(function (JobinfoHotelEnum) {
    JobinfoHotelEnum[JobinfoHotelEnum["SoloRoom"] = 0] = "SoloRoom";
    JobinfoHotelEnum[JobinfoHotelEnum["DoubleRoom"] = 1] = "DoubleRoom";
    JobinfoHotelEnum[JobinfoHotelEnum["ManyRoom"] = 2] = "ManyRoom";
    JobinfoHotelEnum[JobinfoHotelEnum["House"] = 3] = "House";
    JobinfoHotelEnum[JobinfoHotelEnum["Hotel"] = 4] = "Hotel";
})(JobinfoHotelEnum || (JobinfoHotelEnum = {}));
export const JobinfoHotelList = [
    { key: JobinfoHotelEnum.SoloRoom, value: "一人部屋" },
    { key: JobinfoHotelEnum.DoubleRoom, value: "二人部屋" },
    { key: JobinfoHotelEnum.ManyRoom, value: "多数一室(3名以上1室等)" },
    { key: JobinfoHotelEnum.House, value: "一戸(各個室・風呂、トイレ共有)" },
    { key: JobinfoHotelEnum.Hotel, value: "ホテル等" }
];
export var JobinfoOtherConditionsEnum;
(function (JobinfoOtherConditionsEnum) {
    JobinfoOtherConditionsEnum[JobinfoOtherConditionsEnum["HighwayFee"] = 0] = "HighwayFee";
    JobinfoOtherConditionsEnum[JobinfoOtherConditionsEnum["HighwayGasolineFee"] = 1] = "HighwayGasolineFee";
    JobinfoOtherConditionsEnum[JobinfoOtherConditionsEnum["HolidayCommutingAllowance"] = 2] = "HolidayCommutingAllowance";
    JobinfoOtherConditionsEnum[JobinfoOtherConditionsEnum["OvertimePremium"] = 3] = "OvertimePremium";
    JobinfoOtherConditionsEnum[JobinfoOtherConditionsEnum["MidnightSurcharge"] = 4] = "MidnightSurcharge";
    JobinfoOtherConditionsEnum[JobinfoOtherConditionsEnum["HavingParkingLot"] = 5] = "HavingParkingLot";
    JobinfoOtherConditionsEnum[JobinfoOtherConditionsEnum["WithMeal"] = 6] = "WithMeal";
})(JobinfoOtherConditionsEnum || (JobinfoOtherConditionsEnum = {}));
export const JobinfoOtherConditionsList = [
    { key: JobinfoOtherConditionsEnum.HighwayFee, value: "通勤高速代" },
    { key: JobinfoOtherConditionsEnum.HighwayGasolineFee, value: "通勤ガソリン代" },
    { key: JobinfoOtherConditionsEnum.HolidayCommutingAllowance, value: "休日出勤手当" },
    { key: JobinfoOtherConditionsEnum.OvertimePremium, value: "残業割増" },
    { key: JobinfoOtherConditionsEnum.MidnightSurcharge, value: "深夜割増" },
    { key: JobinfoOtherConditionsEnum.HavingParkingLot, value: "宿泊施設の駐車場有り" },
    { key: JobinfoOtherConditionsEnum.WithMeal, value: "出張朝夕食事付" }
];
//動画一覧のカテゴリー
export var VideoCategoryType;
(function (VideoCategoryType) {
    VideoCategoryType[VideoCategoryType["Beginner"] = 0] = "Beginner";
    VideoCategoryType[VideoCategoryType["Middle"] = 1] = "Middle";
    VideoCategoryType[VideoCategoryType["Master"] = 2] = "Master";
})(VideoCategoryType || (VideoCategoryType = {}));
export const VideoCategoryTypeList = [
    { key: VideoCategoryType.Beginner, value: '初級編' },
    { key: VideoCategoryType.Middle, value: '中級編' },
    { key: VideoCategoryType.Master, value: '上級編' },
];
export const VideoCategorySearchList = [allObject, ...VideoCategoryTypeList];
export var VideoStatusType;
(function (VideoStatusType) {
    VideoStatusType[VideoStatusType["invalid"] = 0] = "invalid";
    VideoStatusType[VideoStatusType["valid"] = 1] = "valid";
})(VideoStatusType || (VideoStatusType = {}));
export const VideoStatusTypeList = [
    { key: VideoStatusType.invalid, value: '無効' },
    { key: VideoStatusType.valid, value: '有効' },
];
export const VideoStatusSearchList = [allObject, ...VideoStatusTypeList];
//動画パッケージの公開状態
export var VideoPackOpenStatus;
(function (VideoPackOpenStatus) {
    VideoPackOpenStatus[VideoPackOpenStatus["Unopen"] = 0] = "Unopen";
    VideoPackOpenStatus[VideoPackOpenStatus["Open"] = 1] = "Open";
})(VideoPackOpenStatus || (VideoPackOpenStatus = {}));
export const VideoPackOpenStatusList = [
    { key: VideoPackOpenStatus.Open, value: '公開' },
    { key: VideoPackOpenStatus.Unopen, value: '非公開' },
];
//動画の公開状態
export var VideoOpenStatus;
(function (VideoOpenStatus) {
    VideoOpenStatus[VideoOpenStatus["Unopen"] = 0] = "Unopen";
    VideoOpenStatus[VideoOpenStatus["Open"] = 1] = "Open";
})(VideoOpenStatus || (VideoOpenStatus = {}));
export const VideoOpenStatusList = [
    { key: VideoPackOpenStatus.Open, value: '公開' },
    { key: VideoPackOpenStatus.Unopen, value: '非公開' },
];
export const VideoPackOpenStatusSearchList = [allObject, ...VideoPackOpenStatusList];
//動画一覧のモーダル
export var VideoModalType;
(function (VideoModalType) {
    VideoModalType[VideoModalType["Detail"] = 1] = "Detail";
    VideoModalType[VideoModalType["New"] = 2] = "New";
    VideoModalType[VideoModalType["Edit"] = 3] = "Edit";
})(VideoModalType || (VideoModalType = {}));
//動画サンプルの公開状態
export var VideoSampleOpenStatus;
(function (VideoSampleOpenStatus) {
    VideoSampleOpenStatus[VideoSampleOpenStatus["Unopen"] = 0] = "Unopen";
    VideoSampleOpenStatus[VideoSampleOpenStatus["Open"] = 1] = "Open";
})(VideoSampleOpenStatus || (VideoSampleOpenStatus = {}));
export const VideoSampleOpenStatusList = [
    { key: VideoPackOpenStatus.Open, value: '公開' },
    { key: VideoPackOpenStatus.Unopen, value: '非公開' },
];
//本人確認書類の確認タイプ
export var UnConfirmDocumentStatus;
(function (UnConfirmDocumentStatus) {
    UnConfirmDocumentStatus[UnConfirmDocumentStatus["Company_Unapproved"] = 0] = "Company_Unapproved";
    UnConfirmDocumentStatus[UnConfirmDocumentStatus["User_Unapproved"] = 1] = "User_Unapproved"; // 職人の未確認書類がある場合
})(UnConfirmDocumentStatus || (UnConfirmDocumentStatus = {}));
//システム設定 割引プラン
export var SettingPlanDiscountStatus;
(function (SettingPlanDiscountStatus) {
    SettingPlanDiscountStatus[SettingPlanDiscountStatus["regular"] = 0] = "regular";
    SettingPlanDiscountStatus[SettingPlanDiscountStatus["initial_discount"] = 1] = "initial_discount";
})(SettingPlanDiscountStatus || (SettingPlanDiscountStatus = {}));
export const SettingPlanDiscountStatusList = [
    { key: SettingPlanDiscountStatus.regular, value: '通常' },
    { key: SettingPlanDiscountStatus.initial_discount, value: '初回割引' }
];
